/**
 * @class
 * @description Wrapper class that injects our modified hlsjs loader in a JwPlayer instance.
 * @exports JwPlayer
 */
export default class JwPlayer {
    /**
     * Constructs JwPlayer adapter.
     * @param {Object} player JwPlayer player instance.
     */
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    constructor(player) {
        this._player = player;
        this._loadEngine();
    }
    /**
     * Loads the CDN-P2P engine from hlsjs, and tracking mechanism too.
     * @private
     */
    _loadEngine() {
        setTimeout(() => {
            var _a, _b;
            try {
                if ((_b = (_a = this._player) === null || _a === void 0 ? void 0 : _a.hls) === null || _b === void 0 ? void 0 : _b.config) {
                    this._player.hls.config.loader = JwPlayer._adapters.getLoaders().LoaderHlsjs;
                }
                else {
                    this._loadEngine();
                }
            }
            catch (err) {
                console.error(err);
            }
        }, 250);
    }
}
